import { ReplaySubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class AppFooterService {
  private stream$: Subject<{ action: string }> = new ReplaySubject<{
    action: string;
  }>(null);
  constructor() {}
  open() {
    this.stream$.next({ action: 'OPEN' });
  }
  hide() {
    this.stream$.next({ action: 'CLOSE' });
  }
  stream() {
    return this.stream$;
  }
}
